module.exports = __webpack_public_path__ + "static/media/no-notes.9a71a951.png";